/**
 * EmbeddedControls — Language, Theme switcher + Full portal button for Bitrix24 iframe
 *
 * Placed in the top-right of the TabNavigation bar.
 * Reuses the same ThemeToggle and LanguageToggle as the main app.
 * The "Full portal" button opens the standalone Aelo app via the SSO bridge
 * (one-time Clerk sign-in ticket) so the user lands already authenticated.
 */

import { ExternalLink, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ThemeToggle } from '@/components/theme/ThemeToggle';
import { LanguageToggle } from '@/components/theme/LanguageToggle';
import { Button } from '@/components/ui/button';
import { useOpenPortal } from '@/hooks/useOpenPortal';

export function EmbeddedControls() {
  const { t } = useTranslation('dashboard');
  const { openPortal, isOpening } = useOpenPortal();

  return (
    <div className="flex items-center gap-1 ml-auto pr-1">
      <LanguageToggle />
      <ThemeToggle />

      {/* Open full Aelo portal in new tab via SSO bridge */}
      <Button
        variant="outline"
        size="md"
        onClick={() => void openPortal()}
        disabled={isOpening}
        aria-label={t('embedded.portalButton')}
        className="gap-2 focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      >
        {isOpening ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <ExternalLink className="h-4 w-4" />
        )}
        <span className="hidden sm:inline">{t('embedded.portalButton')}</span>
      </Button>
    </div>
  );
}
